import type { ReactElement } from "react";

import type { TIconProps } from "../types";

export const Intercom = (props: TIconProps): ReactElement => (
  <svg
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 23 24"
    {...props}
  >
    <g clipPath="url(#intercom_clip0)">
      <path
        id="intercom_layer_4_"
        fill="hsl(from hsl(206 85% 53%) h s 50%)"
        d="M19.9,13.2c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2
	c-0.1-0.1-0.2-0.3-0.2-0.6v-7c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6V13.2
	z M19.6,18c-0.1,0.1-2.9,2.5-8.2,2.5c-5.2,0-8-2.4-8.2-2.5c-0.1-0.1-0.1-0.1-0.2-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.2,0-0.3
	c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.3-0.3,0.5-0.3c0.2,0,0.4,0.1,0.6,0.2c0,0,2.6,2.1,7.2,2.1c4.6,0,7.1-2.1,7.2-2.1
	c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.5,0.3c0.1,0.2,0.2,0.4,0.2,0.6C19.9,17.7,19.8,17.9,19.6,18L19.6,18z M3.1,6.2
	c0-0.2,0.1-0.4,0.3-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.5,0.2C4.5,5.8,4.6,6,4.6,6.2v7c0,0.2-0.1,0.4-0.2,0.6
	c-0.1,0.1-0.3,0.2-0.5,0.2s-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6V6.2z M6.9,4.6c0-0.2,0.1-0.4,0.3-0.5C7.3,4,7.5,3.9,7.7,3.9
	c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.5V15c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2
	C7,15.4,6.9,15.2,6.9,15V4.6z M10.7,4.3c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2
	c0.1,0.1,0.2,0.3,0.2,0.6v11.2c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6
	V4.3z M14.5,4.6c0-0.2,0.1-0.4,0.2-0.6c0.1-0.1,0.3-0.2,0.5-0.2c0.2,0,0.4,0.1,0.5,0.2c0.1,0.1,0.2,0.3,0.2,0.6V15
	c0,0.2-0.1,0.4-0.2,0.6c-0.1,0.1-0.3,0.2-0.5,0.2c-0.2,0-0.4-0.1-0.5-0.2c-0.1-0.1-0.2-0.3-0.2-0.6V4.6z M20.1,0.4H2.9
	c-0.4,0-0.7,0.1-1.1,0.2C1.4,0.7,1.1,0.9,0.8,1.2C0.6,1.5,0.4,1.8,0.2,2.2S0,2.9,0,3.3v17.4c0,0.4,0.1,0.8,0.2,1.1
	c0.1,0.4,0.4,0.7,0.6,0.9c0.3,0.3,0.6,0.5,0.9,0.6c0.3,0.1,0.7,0.2,1.1,0.2h17.2c0.4,0,0.7-0.1,1.1-0.2c0.3-0.1,0.7-0.4,0.9-0.6
	c0.3-0.3,0.5-0.6,0.6-0.9c0.1-0.4,0.2-0.7,0.2-1.1V3.3c0-0.4-0.1-0.8-0.2-1.1c-0.1-0.4-0.4-0.7-0.6-0.9c-0.3-0.3-0.6-0.5-0.9-0.6
	C20.9,0.4,20.5,0.4,20.1,0.4"
      />
    </g>
    <defs>
      <clipPath id="intercom_clip0">
        <rect x="-0.1" y="0.4" width="23.3" height="23.3" />
      </clipPath>
    </defs>
  </svg>
);
